import { MutationTree } from 'vuex';
import { UsersState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<UsersState> = {
	SET_USERS(state: UsersState, users: Auth0User[]): void {
		Vue.set(state, 'users', users);
	},

	SET_COUNT(state: UsersState, count: number): void {
		Vue.set(state, 'count', count);
	}
};
